export * from './en/p1'



// WEBPACK FOOTER //
// ./src/common/lang/en.js